export default __webpack_public_path__ + "4ba41a3449698f53ea637ddf49a7e606.png";